/** DEA controlled-substance schedules that should use the controlled (yellow) pill styling. */
const CONTROLLED_DEA_SCHEDULES = new Set(['CI', 'CII', 'CIII', 'CIV', 'CV']);

export function isControlledDeaSchedule(
  deaSchedule: string | null | undefined
): boolean {
  if (deaSchedule == null || deaSchedule === '') return false;
  return CONTROLLED_DEA_SCHEDULES.has(deaSchedule.trim());
}

export type WarehouseProductShape = {
  title?: string | null;
  fdaProduct?: {
    elevenDigitNdc?: string | null;
    deaSchedule?: string | null;
  } | null;
  upcProduct?: {
    upc?: string | null;
  } | null;
};

/** Label shown in the schedule pill (never empty). */
export function getWarehouseScheduleLabel(product: WarehouseProductShape | null | undefined): string {
  const fromFda = product?.fdaProduct?.deaSchedule?.trim();
  if (fromFda) return fromFda;
  if (product?.upcProduct) return 'OTC';
  return '—';
}

export function formatWarehouseNdcOrUpc(
  product: WarehouseProductShape | null | undefined
): string | null {
  const ndc = product?.fdaProduct?.elevenDigitNdc?.trim();
  if (ndc) return ndc;
  const upc = product?.upcProduct?.upc?.trim();
  if (upc) return upc;
  return null;
}
